export default {
  "content": "<path d=\"M18 16h4v2h-4v4h-2v-4h-4v-2h4v-4h2v4z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 3a2 2 0 012 2v6h-2v-1H5v9h6v2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zM5 8h14V5H5v3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};